export default text =>
  text.replace(/_./g, textPart => textPart.toUpperCase()[1])
